import React from "react"
import {
  Formik,
  Form as FormikForm,
  Field,
  //useFormikContext
} from "formik"
import * as Yup from "yup"
import * as Constants from "../../common/constants"
import * as ErrorMessage from "../../common/errorMessage"
import * as Regex from "../../common/regex"
import * as Alert from "../../services/sweetalertService"
import * as API from "../../services/httpService"
import { navigate } from "gatsby"
import { Row, Col } from "react-bootstrap"
import FormTextbox from "../shared/formTextbox"
import FormFieldDisableAutoComplete from "../shared/formFieldDisableAutoComplete"
import FormMobileTextBox from "../shared/formMobileTextBox"
import FormDropdownArray from "../shared/formDropdownArray"
import CustomFormPostalCode from "../shared/customFormPostalCode"
import {
  pageIncrement,
  updateClickedNext,
  updateValidFormData,
  controlLoading,
  updateUiData,
  updateFromGetData,
} from "../../redux/actions"
import { useDispatch, batch } from "react-redux"

const PolicyInformation = ({ claimData, uiData }) => {
  // console.log("PolicyInformation rendered!")
  const {
    pageNumber,
    clickedNext,
    draftFolderPrefix,
    occupationList,
    hideHeaderFooter,
  } = uiData

  const dispatch = useDispatch()
  const [autoPopulated, setAutoPopulated] = React.useState(false)
  const formRef = React.useRef()

  const policyInfoSchema = Yup.object().shape({
    policyNumber: Yup.string()
      .length(8, ErrorMessage.policyNumber)
      .required(ErrorMessage.policyNumber),
    //   .matches(Regex.policyPattern, ErrorMessage.policyNumber)

    hdbReferenceNo: Yup.string()
      .length(11, ErrorMessage.hdbReferenceNo)
      .required(ErrorMessage.hdbReferenceNo),

    unitNo: Yup.string()
      .min(4, ErrorMessage.unitNo)
      .max(8, ErrorMessage.unitNo)
      .required(ErrorMessage.unitNo),

    claimantName: Yup.string()
      .required(ErrorMessage.claimantName)
      .matches(Regex.namepattern, ErrorMessage.claimantName),

    claimantNricNumber: Yup.string()
      .required(ErrorMessage.claimantNricNumber)
      .min(9, ErrorMessage.claimantNricNumber)
      .max(10, ErrorMessage.claimantNricNumber)
      .test("claimantNricNumber", ErrorMessage.claimantNricNumber, value => {
        if (value) {
          const nricRegex = RegExp(Regex.nricpattern)
          const uenRegex = RegExp(Regex.uenpattern)

          if (nricRegex.test(value) || uenRegex.test(value)) {
            return true
          } else {
            return false
          }

          // return nricRegex.test(value) || uenRegex.test(value) ? true : false
        } else {
          return true
        }
      }),

    // residentialAddress: Yup.string().required(ErrorMessage.residentialAddress),

    postalCode: Yup.string().length(6, ErrorMessage.postalCode).required(ErrorMessage.postalCode),

    claimantEmail: Yup.string()
      .required(ErrorMessage.claimantEmail)
      .email(ErrorMessage.claimantEmail),

    claimantMobile: Yup.string()
      .length(8, ErrorMessage.claimantMobile)
      .required(ErrorMessage.claimantMobile)
      .matches(Regex.mobilepattern, ErrorMessage.claimantMobile),

    // occupation: Yup.string().required(ErrorMessage.occupation),

    // otherOccupation: Yup.string().when("occupation", {
    //   is: value => value === "Others",
    //   then: Yup.string().required(ErrorMessage.otherOccupation),
    // }),
  })

  return (
    <Formik
      initialValues={Object.assign({}, claimData["claimFireDetail"])}
      enableReinitialize={true}
      validationSchema={policyInfoSchema}
      validateOnMount={true}
      innerRef={formRef}
      onSubmit={(values, actions) => {}}
    >
      {({ handleSubmit, isValid, values, errors }) => (
        <FormikForm onSubmit={handleSubmit}>
          <Row
            className={
              pageNumber === Constants.policyInfoPageNumber ? "" : "hide"
            }
          >
            <div
              className={
                "title text-center " +
                " " +
                (hideHeaderFooter ? "MarginTop15" : "MarginTop75")
              }
            >
              Submit online HDB Fire claim
            </div>
            <Row className={"containerBody marginTop3x"}>
              <Col
                xs={{ span: 12, offset: 0 }}
                md={{ span: 12, offset: 0 }}
                className="formContainer"
              >
                <div className="horizontal-align marginBottom1x">
                  <Col xs={12} md={12}>
                    <div
                      className={
                        "titleText " +
                        (pageNumber !== Constants.policyInfoPageNumber
                          ? "hide"
                          : "")
                      }
                    >
                      Policy Information
                    </div>
                  </Col>
                </div>
                <div>
                  {/* Fake fields are a workaround for chrome autofill getting the wrong fields */}
                  <Field
                    textDesc={"Disable Auto Complete"}
                    name="disableAutoComplete"
                    component={FormFieldDisableAutoComplete}
                  />
                  <Field
                    textDesc={"Certificate Number"}
                    maxLength={13}
                    name="hdbReferenceNo"
                    component={FormTextbox}
                    onHandleBlur={e => {
                      if(e !== undefined && e !== "")
                      enquiryHdbAPI(e,setAutoPopulated, formRef)
                      else
                      setAutoPopulated(false)
                    }}
                    toUpperCase={false}
                    // asterisk={true}
                  />
                  <Field
                    textDesc={"Policy Number"}
                    maxLength={8}
                    name="policyNumber"
                    component={FormTextbox}
                    toUpperCase={true}
                    disabled={autoPopulated}
                  />
                </div>
              </Col>
            </Row>

            <Row className={"containerBody marginTop3x"}>
              <Col
                xs={{ span: 12, offset: 0 }}
                md={{ span: 12, offset: 0 }}
                className="formContainer"
              >
                <div className="horizontal-align marginBottom1x">
                  <Col xs={12} md={12}>
                    <div
                      className={
                        "titleText " +
                        (pageNumber !== Constants.policyInfoPageNumber
                          ? "hide"
                          : "")
                      }
                    >
                      The Insured
                    </div>
                  </Col>
                </div>
                <div>
                  <input hidden readOnly />
                  
                  <Field
                    textDesc="Postal Code"
                    maxLength={6}
                    name="postalCode"
                    targetModel="residentialAddress"
                    component={CustomFormPostalCode}
                    disabled={autoPopulated}
                    // asterisk={true}
                  />
                  <Field
                    textDesc={"Address"}
                    maxLength={100}
                    name="residentialAddress"
                    component={FormTextbox}
                    disabled={autoPopulated}
                  />
                  <Field
                    textDesc={"Unit No."}
                    maxLength={8}
                    name="unitNo"
                    component={FormTextbox}
                    disabled={autoPopulated}
                    // asterisk={true}
                  />
                  <Field
                    textDesc={"Name"}
                    maxLength={100}
                    name="claimantName"
                    component={FormTextbox}
                    toUpperCase={true}
                    // asterisk={true}
                  />
                  <Field
                    textDesc={"NRIC / FIN"}
                    maxLength={10}
                    name="claimantNricNumber"
                    component={FormTextbox}
                    toUpperCase={true}
                    // asterisk={true}
                  />
                  <Field
                    textDesc={"Mobile No."}
                    maxLength={8}
                    name="claimantMobile"
                    component={FormMobileTextBox}
                    // asterisk={true}
                  />
                  <Field
                    textDesc={"Email"}
                    maxLength={100}
                    name="claimantEmail"
                    component={FormTextbox}
                    // asterisk={true}
                  />
                  {/* <Field
                    textDesc={"Occupation"}
                    name="occupation"
                    component={FormDropdownArray}
                    propertyName={"Occupation"}
                    dropdownItem={occupationList}
                    extraFieldValue={["Others"]}
                    affectedField={["otherOccupation"]}
                  /> */}
                  {/* {values.occupation && values.occupation === "Others" && (
                    <Field
                      textDesc={"Other Occupation"}
                      maxLength={50}
                      name="otherOccupation"
                      component={FormTextbox}
                      toUpperCase={false}
                    />
                  )} */}
                </div>
              </Col>
            </Row>
          </Row>
          <HandleFormValidation
            currentPageClickedNext={clickedNext[Constants.policyInfoPageNumber]}
            formRef={formRef}
            values={values}
            pageNumber={Constants.policyInfoPageNumber}
            dispatch={dispatch}
            draftFolderPrefix={draftFolderPrefix}
          />
        </FormikForm>
      )}
    </Formik>
  )
}

const HandleFormValidation = ({
  currentPageClickedNext,
  formRef,
  values,
  pageNumber,
  dispatch,
  draftFolderPrefix,
}) => {
  React.useEffect(() => {
    if (values.isClaimantPolicyholder) {
      values.claimantName = values.policyHolderName
    }
    if (currentPageClickedNext) {
      formRef.current.validateForm().then(errors => {
        // console.log(errors)

        if (Object.entries(errors).length === 0) {
          // console.log("PASS")
          batch(() => {
            dispatch(updateValidFormData("claimFireDetail", values))
            // dispatch(pageIncrement())
            dispatch(updateClickedNext(pageNumber, false))
          })
          getPolicyInfoAPI(values, dispatch, draftFolderPrefix)
        } else {
          // console.log("FAIl")
          Alert.missingInfoAlert()
          formRef.current.submitForm() // Set touched to all fields
          batch(() => {
            dispatch(updateClickedNext(pageNumber, false))
          })
        }
      })
    }
  }, [
    formRef,
    values,
    pageNumber,
    dispatch,
    currentPageClickedNext,
    draftFolderPrefix,
  ])
  return null
}

const getPolicyInfoAPI = (values, dispatch, draftFolderPrefix) => {
  dispatch(controlLoading())

  //Call API to validate Fire policy
  const validatePolicyPromise = API.apiPostRequest(
    "/Claim/FireValidatePolicyInfo",
    {
      PolicyNumber: values.policyNumber,
      PolicyHolderName: values.claimantName,
      NRIC: values.claimantNricNumber,
    },
    null
  )

  //Call API to get required documents for Basic coverage
  const getRequiredDocumentPromise = API.apiPostRequest(
    "/Claim/GetRequiredDocumentList",
    {
      coverageId: Constants.basicCoverageDetailId,
    },
    null
  )

  Promise.all([validatePolicyPromise, getRequiredDocumentPromise])
    .then(values => {
      const validatePolicyResult = values[0].data
      const requiredDocumentResult = values[1].data

      // if (
      //   validatePolicyResult.IsValidPolicy.toLowerCase() !== "y" &&
      //   validatePolicyResult.UpStatus.toLowerCase() === "true"
      // ) {
      //   Alert.policyValidationAlert()
      //   dispatch(controlLoading())
      // } else {
        batch(() => {
          dispatch(updateUiData("proofDocuments", requiredDocumentResult))
          dispatch(
            updateUiData("folderName", generateFolderName(draftFolderPrefix))
          )
          dispatch(
            updateUiData("policyStartDate", validatePolicyResult.StartDate)
          )
          dispatch(
            updateUiData("policyEndDate", validatePolicyResult.EndDate)
          )
          dispatch(
            updateFromGetData("planPeriodFrom", validatePolicyResult.StartDate)
          )
          dispatch(
            updateFromGetData("planPeriodTo", validatePolicyResult.EndDate)
          )
          dispatch(
            updateValidFormData("claimAttributeModel", {
              ContractType: validatePolicyResult.ProductType,
            })
          )
          dispatch(pageIncrement())
          dispatch(controlLoading())
        })
      //}
    })
    .catch(error => {
      navigate("errorOccurred")
    })
}

const enquiryHdbAPI = (hdbNo, setAutoPopulated, formRef) => {

  //Call API to enquiry Hdb Info
  const enquiryHdbPromise = API.apiPostRequest(
    "/Claim/HdbFireEnquiryInfo",
    {
      HdbReferenceNo: hdbNo,
    },
    null
  )

  Promise.all([enquiryHdbPromise])
    .then(values => {
      const enquiryHdbResult = values[0].data
        formRef.current.setFieldValue("policyNumber",enquiryHdbResult.PolicyNumber)
        formRef.current.setFieldValue("postalCode",enquiryHdbResult.PostalCode)
        formRef.current.setFieldValue("residentialAddress",enquiryHdbResult.Address)
        formRef.current.setFieldValue("unitNo",enquiryHdbResult.UnitNo)
        setAutoPopulated(true)
    })
    .catch(error => {
    })
}

const generateFolderName = draftFolderPrefix => {
  let dd = new Date()
  let ss =
    "" +
    dd.getYear() +
    dd.getMonth() +
    dd.getDate() +
    dd.getHours() +
    dd.getMinutes() +
    dd.getSeconds()

  return draftFolderPrefix + ss
}
export default PolicyInformation
